import { RouteLoader, useUser } from '@dofleini/security';
import { users } from '@mep/pae-commons';
import React, { memo, Suspense, useMemo } from 'react';

import PageLoader from '@/components/PageLoader';
import { ROUTE_PATH_EXPEDIENT } from '@/modules/proposalFiles/contants/expedient';
import { ROUTE_PATH_PROPOSAL_REQUEST } from '@/modules/proposalRequest/contants/proposalRequest';

import routes from './routes-modules';

const { USER_TYPES } = users;

const MainRouter = () => {
  const { user, hasPermission } = useUser();
  
  const notfoundRedirect = useMemo(() => {
    if (!hasPermission('ADMIN')) {
      switch (user?.userType) {
        case USER_TYPES.HISTORIAN:
          return ROUTE_PATH_PROPOSAL_REQUEST;
        case USER_TYPES.NOTARY:
        case USER_TYPES.NOTARY_DPJ:
          return ROUTE_PATH_EXPEDIENT;
        default:
          return '/';
      }
    }
    return '/';
  }, [hasPermission, user?.userType]);
  
  return (
    <Suspense fallback={<PageLoader/>}>
      <RouteLoader routes={routes} notfoundRedirect={notfoundRedirect}/>
    </Suspense>
  );
};

export default memo(MainRouter);
